import apiClient from './apiClient';

export type NotificationEventType = 
  | 'APPOINTMENT_CONFIRMATION' 
  | 'APPOINTMENT_REMINDER_24H' 
  | 'APPOINTMENT_REMINDER_1H' 
  | 'APPOINTMENT_CANCELLATION';

export interface SalonNotificationTemplate {
    id?: string;
    salonId: string;
    eventType: NotificationEventType;
    templateBody: string;
    enabled: boolean;
}

export const notificationApi = {
    getTemplates: async (salonId: string): Promise<SalonNotificationTemplate[]> => {
        const response = await apiClient.get<SalonNotificationTemplate[]>(`/notifications/templates/${salonId}`);
        return response.data;
    },

    updateTemplate: async (salonId: string, data: SalonNotificationTemplate): Promise<SalonNotificationTemplate> => {
        const response = await apiClient.put<SalonNotificationTemplate>(`/notifications/templates/${salonId}`, data);
        return response.data;
    },
    
    // Helper to get default templates (mocked for now, or could be a real endpoint)
    getDefaults: (): Record<NotificationEventType, string> => ({
        APPOINTMENT_CONFIRMATION: "¡Hola {clientName}! 👋 Tu cita para {serviceName} ha sido confirmada para el {date} a las {time}. ¡Nos vemos pronto!",
        APPOINTMENT_REMINDER_24H: "¡Hola {clientName}! ⏰ Recordatorio: Mañana tienes tu cita de {serviceName} a las {time}. Confirma aquí: {link}",
        APPOINTMENT_REMINDER_1H: "¡Hola {clientName}! 👋 Tu cita de {serviceName} es en 1 hora ({time}). ¡Te esperamos!",
        APPOINTMENT_CANCELLATION: "Hola {clientName}, lamentamos informarte que tu cita para {serviceName} ha sido cancelada."
    })
};
